<script setup>
const props = defineProps({
  allocation: {
    type: Array,
    default: () => [],
  },
})

const colors = ['#7c3aed', '#06b6d4', '#22c55e', '#f59e0b', '#ef4444', '#64748b']

const barStyle = computed(() => {
  let cursor = 0
  const stops = props.allocation.map(item => {
    const start = cursor
    cursor += item.percent
    return `${colors[item.colorIndex % colors.length]} ${start}% ${cursor}%`
  })

  return { background: stops.length ? `linear-gradient(90deg, ${stops.join(', ')})` : 'rgba(148, 163, 184, 0.18)' }
})
</script>

<template>
  <VCard class="review-widget allocation-widget">
    <VCardText class="pa-5">
      <div class="d-flex align-center justify-space-between gap-4 mb-4">
        <div>
          <div class="text-overline text-warning mb-1">{{ $t('dashboard.weeklyReview.allocationOverline') }}</div>
          <h2 class="text-h6 font-weight-bold mb-0">{{ $t('dashboard.weeklyReview.projectAllocation') }}</h2>
        </div>
        <VIcon icon="mdi-chart-timeline-variant" color="warning" size="28" />
      </div>

      <div class="allocation-bar mb-4" :style="barStyle" />

      <div v-if="!allocation.length" class="text-body-2 text-medium-emphasis">
        Complete tasks to see where your usable time went.
      </div>

      <div v-else class="allocation-list">
        <div v-for="item in allocation" :key="item.id" class="allocation-item">
          <span class="allocation-dot" :style="{ background: colors[item.colorIndex % colors.length] }" />
          <span class="text-body-2 text-truncate">{{ item.label }}</span>
          <span class="text-caption text-medium-emphasis ms-auto">{{ item.hours }}h · {{ item.percent }}%</span>
        </div>
      </div>
    </VCardText>
  </VCard>
</template>

<style scoped lang="scss">
.review-widget {
  block-size: 100%;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(var(--v-theme-surface), 0.86), rgba(var(--v-theme-surface), 0.64)),
    rgba(8, 12, 20, 0.72);
  backdrop-filter: blur(14px) saturate(1.1);
}

.allocation-bar {
  block-size: 18px;
  border-radius: 999px;
  box-shadow: inset 0 0 0 1px rgba(var(--v-border-color), 0.16);
}

.allocation-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.allocation-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-inline-size: 0;
}

.allocation-dot {
  flex: 0 0 auto;
  inline-size: 10px;
  block-size: 10px;
  border-radius: 50%;
}
</style>
